export const FLEET_STATUS_COLOR_SCHEME = {
  DOCUMENT_EXPIRED: 'darkGrey',
  REJECTED: 'danger',
  UNVERIFIED: 'warning',
  VERIFIED: 'success',
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const enum UPLOAD_TYPE {
  CREATE_NEW_FLEET,
  UPDATE_EXISTING_FLEET,
}

// eslint-disable-next-line @typescript-eslint/naming-convention
export const enum DOWNLOAD_TYPE {
  EXISTING_FLEET_DATA,
}

export const FLEET_UPLOAD = [
  {
    key: UPLOAD_TYPE.CREATE_NEW_FLEET,
    label: 'create_new_fleet',
  },
  {
    key: UPLOAD_TYPE.UPDATE_EXISTING_FLEET,
    label: 'update_existing_fleet',
  },
];

export const FLEET_DOWNLOAD = [
  {
    key: DOWNLOAD_TYPE.EXISTING_FLEET_DATA,
    label: 'existing_fleet_data',
  },
];

export const DEFAULT_SORT = {
  sortBy: 'UPDATED_AT',
  sortOrder: 'DESC',
};

export const FLEET_PLATE_COLOR = {
  BLACK: 'BLACK_PLATE',
  YELLOW: 'YELLOW_PLATE',
};

export const FLEET_SEARCH_QUERIES = {
  CONTRACT_CODE: 'searchContractCode',
  FLEET_ID: 'searchFleetId',
  FLEET_PLATE: 'searchLicensePlate',
  TRANSPORTER_ID: 'searchTransporterId',
};

export const FLEET_FILTER_QUERIES = {
  BODY_TYPE: 'searchFleetTypes-subtype',
  DEDICATED: 'searchDedicatedToSpecificContract',
  DOCUMENT_TYPE: 'searchDocumentTypes',
  PLATE_COLOR: 'searchFleetPlateColors',
  STATUS: 'searchFleetStatuses',
  TYPE: 'searchFleetTypes-type',
};

export const plateColorOptions = (tl) => [
  {
    label: tl(`fleet.plate_colors.${FLEET_PLATE_COLOR.BLACK}`),
    value: FLEET_PLATE_COLOR.BLACK,
  },
  {
    label: tl(`fleet.plate_colors.${FLEET_PLATE_COLOR.YELLOW}`),
    value: FLEET_PLATE_COLOR.YELLOW,
  },
];
